<template>
  <basic-container>
    <avue-crud :option="option"
               :data="data"
               :page.sync="page"
               ref="crud"
               @row-del="rowDel"
               v-model="form"
               :permission="permissionList"
               @row-update="rowUpdate"
               @row-save="rowSave"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @refresh-change="refreshChange"
               @selection-change="selectionChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.user_wxuserdetail_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, submit, remove } from '@/api/user/wxuserdetail'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [{
              required: true,
              message: '请输入主键'
            }]
          },
          {
            label: '公众号appid',
            prop: 'appid',
            rules: [{
              required: true,
              message: '请输入公众号appid'
            }]
          },
          {
            label: 'appUserId',
            prop: 'appUserId',
            rules: [{
              required: true,
              message: '请输入appUserId'
            }]
          },
          {
            label: 'openid',
            prop: 'openId',
            rules: [{
              required: true,
              message: '请输入openid'
            }]
          },
          {
            label: '昵称',
            prop: 'nickname',
            rules: [{
              required: true,
              message: '请输入昵称'
            }]
          },
          {
            label: '性别',
            prop: 'sex',
            rules: [{
              required: true,
              message: '请输入性别'
            }]
          },
          {
            label: '语言',
            prop: 'language',
            rules: [{
              required: true,
              message: '请输入语言'
            }]
          },
          {
            label: '城市',
            prop: 'city',
            rules: [{
              required: true,
              message: '请输入城市'
            }]
          },
          {
            label: '省份',
            prop: 'province',
            rules: [{
              required: true,
              message: '请输入省份'
            }]
          },
          {
            label: '国家地区',
            prop: 'country',
            rules: [{
              required: true,
              message: '请输入国家地区'
            }]
          },
          {
            label: '微信头像',
            prop: 'headImgUrl',
            rules: [{
              required: true,
              message: '请输入微信头像'
            }]
          },
          {
            label: '订阅状态，0未关注，1已关注',
            prop: 'subscribe',
            rules: [{
              required: true,
              message: '请输入订阅状态，0未关注，1已关注'
            }]
          },
          {
            label: '订阅时间',
            prop: 'subscribeTime',
            rules: [{
              required: true,
              message: '请输入订阅时间'
            }]
          },
          {
            label: 'unionid',
            prop: 'subscribeScene',
            rules: [{
              required: true,
              message: '请输入unionid'
            }]
          },
          {
            label: '二维码扫码场景',
            prop: 'qrScene',
            rules: [{
              required: true,
              message: '请输入二维码扫码场景'
            }]
          },
          {
            label: 'unionid',
            prop: 'unionId',
            rules: [{
              required: true,
              message: '请输入unionid'
            }]
          },
          {
            label: '备注',
            prop: 'remark',
            rules: [{
              required: true,
              message: '请输入备注'
            }]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            rules: [{
              required: true,
              message: '请输入创建时间'
            }]
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            rules: [{
              required: true,
              message: '请输入修改时间'
            }]
          },
          {
            label: '乐观锁',
            prop: 'revision',
            rules: [{
              required: true,
              message: '请输入乐观锁'
            }]
          },
          {
            label: '类型 1 测试人员',
            prop: 'type',
            rules: [{
              required: true,
              message: '请输入类型 1 测试人员'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.permission.user_wxuserdetail_add,
        viewBtn: this.permission.user_wxuserdetail_view,
        delBtn: this.permission.user_wxuserdetail_delete,
        editBtn: this.permission.user_wxuserdetail_edit
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.onLoad(this.page, params)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    refreshChange (data) {
      this.onLoad(this.page, data.searchForm)
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },

    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad (page, params = {}) {
      getList(page.currentPage, page.pageSize, params).then(res => {
        const data = res.data
        this.page.total = data.total
        this.data = data.records
      })
    }
  }
}
</script>
